module.exports = __webpack_public_path__ + "img/rg_rojo-01.0d7943f6.png";